var map = {
	"./beeline.svg": "1ed7",
	"./bg_row_1.svg": "53ed",
	"./bg_row_1ee.svg": "c15f",
	"./bg_row_1eee.svg": "2f44",
	"./bg_row_1ez.svg": "58ae",
	"./bg_row_2.svg": "bac4",
	"./bg_row_3.svg": "39f3",
	"./bg_row_v1.svg": "20d7",
	"./bg_row_v2.svg": "8596",
	"./bg_row_v3.svg": "f0a7",
	"./calendar-alt-regular.svg": "2a4b",
	"./clock-regular.svg": "0b7b",
	"./coin.svg": "8861",
	"./grid.svg": "47c5",
	"./humans.svg": "f8be",
	"./logo.svg": "9b19",
	"./logo_title.svg": "5373",
	"./logo_w_title.svg": "8519",
	"./meeple.svg": "a69b",
	"./method-draw-image.svg": "a8f2",
	"./mobiuz.svg": "6a3e",
	"./perfectum.svg": "ace9",
	"./search-icon.svg": "d8e7",
	"./timer.svg": "6661",
	"./trophy.svg": "18c1",
	"./ucell.svg": "c8e3",
	"./user-friends-solid.svg": "2b33",
	"./uzmobile.svg": "267d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";